import { CategoryFieldTypeEnum, PostType } from 'types';
import styles from './postInfo.module.scss';
import { TimeDifference } from 'scripts';

export default function PostInfoComp(props: { post: PostType<'detail'> }) {
    return (
        <div className={`${styles['info-text']} mb-4`}>
            {props.post.locations ? (
                <div className="d-flex center-content justify-content-between pb-2 mb-2">
                    <p className="t-p1 t-400 t-l-gray1 t-d-gray2">موقعیت مکانی</p>
                    <p className="t-p1 t-400 t-l-black1 t-d-gray3">
                        {props.post.locations.map((loc, index) => {
                            const isTheLastOne = props.post.locations!.length - 1 === index;
                            // for separating each index(title)
                            return (
                                <span key={loc.id}>
                                    {loc.parent ? loc.parent.title + ' - ' : ''}
                                    {loc.title} {isTheLastOne ? '' : ' ،'}
                                </span>
                            );
                        })}
                    </p>
                </div>
            ) : null}
            <div className="d-flex center-content justify-content-between pb-2 mb-2">
                <p className="t-p1 t-400 t-l-gray1 t-d-gray2">زمان</p>
                <p className="t-p1 t-400 t-l-black1 t-d-gray3">{TimeDifference(props.post.created_at)}</p>
            </div>
            {props.post.category_fields_values
                ?.sort((a, b) => (b.category_field.order ?? 0) - (a.category_field.order ?? 0))
                .map((item, index) => (
                    <div key={index} className="d-flex center-content justify-content-between pb-2 mb-2">
                        <p className="t-p1 t-400 t-l-gray1 t-d-gray2">{item.category_field.title}</p>
                        <p className="t-p1 t-400 t-l-black1 t-d-gray3">
                            {item.category_field.type === CategoryFieldTypeEnum.boolean
                                ? item.value === '1'
                                    ? 'بله'
                                    : 'خیر'
                                : item.category_field.type === CategoryFieldTypeEnum.fieldOptions
                                  ? item.option?.title
                                  : item.category_field.type === CategoryFieldTypeEnum.number
                                    ? item.value_number?.toLocaleString('fa-IR')
                                    : item.category_field.type === CategoryFieldTypeEnum.text
                                      ? item.value
                                      : null}
                            {item.category_field.unit ? ' ' + item.category_field.unit : ''}
                        </p>
                    </div>
                ))}
        </div>
    );
}
